// @ts-nocheck

import PropTypes from "prop-types";
import Chart from "react-apexcharts";

import { theme1 } from "./ChartColors";

const BarChart = ({
  xAxisCategories,
  data,
  height,
  showToolbar,
  showDataLabels,
  customTooltip,
  customOptions,
  customChartOptions,
  stacked,
  horizontal,
}) => {
  const chartData = {
    options: {
      ...theme1,
      plotOptions: {
        bar: {
          horizontal: horizontal,
        },
      },
      dataLabels: {
        enabled: showDataLabels,
      },
      xaxis: {
        categories: xAxisCategories,
      },
      chart: {
        stacked: stacked,
        toolbar: {
          show: showToolbar,
        },
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        ...customChartOptions,
      },
      tooltip: {
        ...customTooltip,
      },
      ...customOptions,
    },
  };
  return (
    <Chart
      options={chartData.options}
      series={data}
      type="bar"
      height={height}
    />
  );
};

BarChart.defaultProps = {
  showToolbar: false,
  showDataLabels: false,
  stacked: false,
  horizontal: false,
  customChartOptions: {},
};

BarChart.propTypes = {
  customOptions: PropTypes.object,
  customChartOptions: PropTypes.object,
  customTooltip: PropTypes.object,
};

export default BarChart;
